import { render, staticRenderFns } from "./FormRulesIndicationsOfDanger.vue?vue&type=template&id=0bece702"
import script from "./FormRulesIndicationsOfDanger.vue?vue&type=script&lang=js"
export * from "./FormRulesIndicationsOfDanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports